module.exports = __webpack_public_path__ + "img/tile-plus-logo-dark-horizontal.08f0b03b.svg";